import { createSelector } from 'reselect'

const getLessonsPicker = state => state.lessonsPicker
const getBinders = state => state.binders

const binder_search_lessons_selector = createSelector(
	[ getLessonsPicker, getBinders ],
	(lessons_picker, binders) => ({
		entityUID: binders.current.entityUID,
		page: lessons_picker.page,
		search: lessons_picker.search,
		order_field: lessons_picker.order_field,
		order_type: lessons_picker.order_type,
	})
)

export default binder_search_lessons_selector
